import {
  Box,
  List,
  ListItem,
  Skeleton,
  SxProps,
  Typography
} from '@mui/material';
import { UserOrganizationSubscriptionItem } from '../types/UserOrganizationSubscriptionItem';
import { Checkbox } from 'components/Checkbox/Checkbox';

const listContainerSx: SxProps = {
  height: '60vh',
  overflow: 'scroll',
  py: 2
};

type Props = {
  userOrganizations: UserOrganizationSubscriptionItem[];
  usersToToggle: string[];
  onToggleUser: (userId: string) => void;
};

export const SubscribersList: React.FC<Props> = ({
  userOrganizations,
  usersToToggle,
  onToggleUser
}) => {
  const checkedUserOrganizations = userOrganizations.map((userOrganization) => {
    const subscription =
      userOrganization.user.campaignSubscriptions?.items?.[0];

    let shouldBeChecked = !!subscription;

    if (usersToToggle.includes(userOrganization.user.id)) {
      shouldBeChecked = !shouldBeChecked;
    }

    return {
      ...userOrganization,
      isChecked: shouldBeChecked
    };
  });

  return (
    <List sx={listContainerSx}>
      {checkedUserOrganizations.map((userOrganization) => (
        <ListItem key={userOrganization.id} disablePadding sx={{ mb: 2 }}>
          <Box display="flex">
            <Box>
              <Checkbox
                inputProps={{
                  'aria-labelledby': `checkbox-list-label-${userOrganization.user.id}`
                }}
                checked={userOrganization.isChecked}
                onChange={() => onToggleUser(userOrganization.user.id)}
                sx={{ pt: 0.6, mr: 1.2 }}
              />
            </Box>
            <Box>
              <Typography fontWeight="bold">
                {userOrganization.user.name}
              </Typography>
              <Typography variant="body2">
                {userOrganization.user.email}
              </Typography>
            </Box>
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export const SubscribersListSkeleton: React.FC = () => (
  <Box>
    {Array.from({ length: 7 }).map((_, index) => (
      <Skeleton
        variant="rectangular"
        width="100%"
        height={60}
        key={`skeleton-loading-${index}`}
        data-testid={`skeleton-loading-${index}`}
        sx={{ mb: 2 }}
      />
    ))}
  </Box>
);
